import { takeEvery, put, all } from "redux-saga/effects"
import { initialize } from "redux-form"
import {
  getPermissions,
  getRolePermissions,
} from "src/engine/repositories/permissions"
import { INIT_FORM } from "../actions/types"
import {
  loadPermissionsStarted,
  loadPermissionsCompleted,
  loadPermissionsFailed,
} from "../actions/creators"
import { permissionListToFormState, FORM_NAME } from "../helpers"

function* initForm(action) {
  const { role } = action.payload

  yield put(loadPermissionsStarted(role))

  try {
    const [{ data: allPermissions }, { data: rolePermissions }] = yield all([
      getPermissions({ limit: -1, orderBy: `title asc` }),
      getRolePermissions({ role, limit: -1 }),
    ])

    yield put(
      initialize(
        FORM_NAME,
        permissionListToFormState(allPermissions, rolePermissions),
      ),
    )

    yield put(loadPermissionsCompleted(allPermissions))
  } catch (error) {
    yield put(loadPermissionsFailed())
  }
}

export default function* initFormWatcher() {
  yield takeEvery(INIT_FORM, initForm)
}
